import { useThreads } from "@liveblocks/react";
import { useAppSelector } from "@store";
import { getCurrentPayloadId } from "@store/story/selectors";
import { type ReactNode, Suspense, useEffect } from "react";
import { useCollaborationStatus } from "../hooks";

export const CommentsCountProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const isCollaborationEnabled = useCollaborationStatus();

  if (isCollaborationEnabled) {
    return (
      <Suspense fallback={children}>
        <Counter>{children}</Counter>
      </Suspense>
    );
  }
  return <>{children}</>;
};

const Counter = ({ children }: { children: ReactNode }) => {
  const storyId = useAppSelector(getCurrentPayloadId);
  const { threads } = useThreads({
    query: { metadata: { storyId }, resolved: false },
  });

  useEffect(() => {
    if (!threads?.length) return;
    const count = threads?.reduce((acc, thread) => {
      const comments = thread.comments.filter((comment) => !!comment.body);
      return acc + comments.length;
    }, 0);

    document.dispatchEvent(
      new CustomEvent("sd-register-property", {
        detail: {
          key: "live comments counter",
          value: count,
        },
      }),
    );
  }, [threads]);

  return <>{children}</>;
};
